import { render, staticRenderFns } from "./suidao.vue?vue&type=template&id=5e6dbc12&scoped=true"
var script = {}
import style0 from "./suidao.vue?vue&type=style&index=0&id=5e6dbc12&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e6dbc12",
  null
  
)

export default component.exports